import React from 'react'
import HeroSection from '../Components/LandingPage/HeroSection'
import BooksGrid from '../Components/LandingPage/BookGrid'
import ServicesParallax from '../Components/LandingPage/ServicesParallax'
import AuthorsOfMonth from '../Components/LandingPage/AuthorsOfMonth'
import GuestHostSection from '../Components/LandingPage/GuestHostSection'
import TravelogueFeature from '../Components/LandingPage/TravelogueFeature'
import GalleryGrid from '../Components/LandingPage/GalleryGrid'

const LandingPage = () => {
  return (
    <div><HeroSection/>
    <BooksGrid />
    <ServicesParallax />

    <GuestHostSection />
    <TravelogueFeature />
    {/* <GalleryGrid /> */}
    </div>
  )
}

export default LandingPage